export default ({
  API_NO_ACCESS: 'No Access',
  API_READ_ONLY_ACCESS: 'Read Only Access',
  API_FULL_ACCESS: 'Full Access',
})
